import { QuestionMarkIcon } from "@radix-ui/react-icons";
import { Plus } from "lucide-react";
import { useMedia } from "react-use";
import { Button } from "@/components/ui/button";
import useManualQuestionModal from "@/features/questions/hooks/use-manual-question-modal";

interface EmptyQuestionsProps {
  handleAddQuestion?: () => void;
  actions?: boolean;
}
const EmptyQuestions = ({
  handleAddQuestion,
  actions,
}: EmptyQuestionsProps) => {
  const { onOpen: onOpenManualModal } = useManualQuestionModal();
  const isMobile = useMedia("(max-width: 768px)", false);
  return (
    <div className="h-[400px] w-full border border-dashed rounded-2xl px-2">
      <div className="flex flex-col items-center justify-center w-full gap-3 h-full">
        <div className="size-12 grid place-items-center rounded border bg-muted/40">
          <QuestionMarkIcon className="size-6" />
        </div>
        <div className="flex flex-col justify-center items-center gap-1 text-center">
          <h3 className="font-semibold text-base leading-6">No Questions</h3>
          <p className="text-sm font-normal leading-5 text-muted-foreground">
            {actions
              ? "You have not created any questions. Create one below."
              : "There are not any questions in this set"}
          </p>
        </div>
        {actions && (
          <Button
            onClick={() => {
              if (isMobile) {
                onOpenManualModal();
              } else {
                handleAddQuestion?.();
              }
            }}
            variant="ghost"
            size="sm"
            className="flex items-center gap-2 text-brand-primary"
          >
            <Plus className="size-4" />
            <span>Add Question</span>
          </Button>
        )}
      </div>
    </div>
  );
};

export default EmptyQuestions;
